import styled from 'styled-components';
import { Link } from 'react-scroll';

export const StyledSrollLink = styled(Link)`
    &:hover {
        cursor: pointer;
    }
`